// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectColorPopper_root__3Ujb9","closeBtn":"SelectColorPopper_closeBtn__34CPp"};